export class User {
  ekpay_id:string;
  user_id:string;
  pass:String;
  mpin:String;
  status:String;
  activated:boolean;
  user_name:String;
  mobile:String;
  email_id:String;
  dob:String;
  gender:String;
  nid:String;
  default_lang:String;
  is_auto_login:boolean;
  is_bill_paid:boolean
  creation_time:String;
  profile_update_time:String;
  created_by:String;
  updated_by:String;
  user_type:String;
  reg_mode:String;
  roles:string[];
}


// WEBPACK FOOTER //
// ./src/app/shared/auth/user.ts